// Admin → Blog categories — layout route. M5, revised 2026-08-15.
//
// ⚠️ `_authed.blog-categories.$id` and `.new` nest under this file, so it MUST
// render an <Outlet/> or the children never mount and every child URL silently
// renders the LIST instead. That bug shipped five times before it was found
// (pages, families, schools, users, content), so the list lives in
// `_authed.blog-categories.index.tsx` from the start, not here.
//
// Verify in routeTree.gen.ts: index, `new` and `$id` must each declare
// `getParentRoute: () => AuthedBlogCategoriesRoute`.
//
// A separate top-level section rather than a nested `/blog/categories`: the
// owner asked for categories to be managed on their own pages, and keeping the
// two trees flat avoids `/blog/$id` ever capturing the literal `categories`.

import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/blog-categories')({
  component: () => <Outlet />,
});
